export const FEATURE_FLAGS_QUERY_KEY = "feature-flags";
export const DOTS_APP_QUERY_KEY = "dots-app";
